export const favoritesTabTypeToSectionName: Record<string, string> = {
  UserFavoritesTab: 'favorites',
  CompanyFavoritesTab: 'favorites-company',
  EmbeddedIframeTab: 'plugin_embedded-iframe',
  TrendingContentTab: 'plugin_trending-contents',
  SmartActionsTab: 'plugin_smart-actions',
  NewContentTab: 'plugin_new-contents',
  SuggestedAnswersTab: 'plugin_suggested-answers',
};
